import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'Чем трансформаторы ТСЛ отличаются от масляных трансформаторов ТМ?',
    answer: 'Трансформаторы ТСЛ (сухие литые) не содержат масла, что исключает риск возгорания и загрязнения окружающей среды. Они компактнее, могут устанавливаться ближе к потребителям, не требуют масляного хозяйства и систем пожаротушения. ТСЛ имеют более длительный срок службы (30+ лет) и меньшие эксплуатационные расходы, хотя начальные инвестиции выше, чем у ТМ.',
  },
  {
    question: 'Каковы сроки производства и доставки трансформаторов?',
    answer: 'Стандартный срок производства трансформаторов ТСЛ и ТСЗ составляет 50-75 дней в зависимости от мощности и комплектации. Доставка осуществляется по всей территории России и стран СНГ в течение 5-15 дней с момента готовности оборудования. Для срочных проектов возможно ускоренное производство.',
  },
  {
    question: 'Какую гарантию предоставляет компания на оборудование?',
    answer: 'Компания «Проминнова» предоставляет стандартную гарантию 36 месяцев на все поставляемое оборудование с даты отгрузки. При заключении договора на сервисное обслуживание возможно продление гарантийного срока. В течение гарантийного периода мы бесплатно устраняем любые заводские дефекты.',
  },
  {
    question: 'Как выбрать подходящий трансформатор для моего проекта?',
    answer: 'Для правильного выбора трансформатора необходимо учитывать несколько ключевых параметров: требуемую мощность, напряжение первичной и вторичной обмоток, тип исполнения (внутреннее/наружное), особенности эксплуатации, климатические условия. Наши технические специалисты помогут подобрать оптимальное решение на основе вашего технического задания. Рекомендуем связаться с нами для бесплатной консультации.',
  },
];

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ответы на частые вопросы</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Мы собрали ответы на самые популярные вопросы о трансформаторах и оборудовании
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-200"
              >
                <button
                  className="w-full flex justify-between items-center p-5 text-left"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="font-medium text-lg">{faq.question}</span>
                  {openIndex === index ? (
                    <ChevronUp className="flex-shrink-0 ml-4 w-5 h-5 text-gray-500" />
                  ) : (
                    <ChevronDown className="flex-shrink-0 ml-4 w-5 h-5 text-gray-500" />
                  )}
                </button>
                <div 
                  className={`px-5 overflow-hidden transition-all duration-200 ${
                    openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-8 text-center">
            <Link to="/faq" className="inline-flex items-center text-lg font-medium text-primary-600 hover:text-primary-700">
              Смотреть все вопросы
              <ChevronDown className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;